export const PERFORMANCES_VIEW_CURRENT = 'PERFORMANCES_VIEW_CURRENT'
export const PERFORMANCES_VIEW_PAST = 'PERFORMANCES_VIEW_PAST'



/** WEBPACK FOOTER **
 ** ./src/constants/eventgroup-page-constants.js
 **/